module.exports = __webpack_public_path__ + "img/mulheravalize.4b941270.png";